/**
 * The library's one built-in shelf.
 *
 * "Case studies" is where `POST /api/library/import-case-study` files what it
 * brings back from rkh.co.uk, and the only shelf whose grid offers the import.
 * That makes it the same kind of thing the Bank calls a built-in category:
 * pinned, never renamed, never deleted, because code keys off its exact name.
 *
 * It lives in `shared/` rather than as a string on each side because the two
 * sides hold halves of the same rule — the server refuses to rename or delete
 * this label, the client decides where the import tile appears by it — so a
 * drift between them would not fail, it would quietly unlock the shelf.
 *
 * A function rather than a `const` because this directory bans exported values
 * outright (see `__tests__/purity.test.ts`); a hoisted function holds no state
 * and does no import-time work, which is the property that ban protects.
 */

/** The built-in shelf imported case studies land on. */
export function caseStudyCategory(): string {
  return 'Case studies';
}

/** True for a category path that cannot be created, renamed or deleted.
 *  Exact match only: sub-categories of it ("Case studies/Acme") stay fully
 *  editable, as `people/clients` does in the Bank. */
export function isLockedLibraryCategory(path: string | null | undefined): boolean {
  return typeof path === 'string' && path.trim().toLowerCase() === caseStudyCategory().toLowerCase();
}
